export default __webpack_public_path__ + "static/media/passed.eaded240.svg";